import { inject, Injectable, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { UserService } from './api/user.service';
import { StoreService } from './store';

type SearchMode = 'user' | 'possibleParticipant' | 'pssrMember' | 'possibleActionItemAssignee';
export interface UserSearchConfig {
  searchMode: SearchMode;
  organizationId?: number;
}

export const USER_SEARCH_CONFIG = new InjectionToken<UserSearchConfig>('USER_SEARCH_CONFIG', {
  providedIn: 'root',
  factory: () => ({
    searchMode: 'user',
  }),
});

export function provideUserSearch(searchMode: SearchMode = 'user') {
  return makeEnvironmentProviders([
    {
      provide: USER_SEARCH_CONFIG,
      useFactory: () => ({ searchMode }),
    },
    UserSearchService,
  ]);
}

@Injectable({
  providedIn: 'root',
})
export class UserSearchService {
  private readonly config = inject(USER_SEARCH_CONFIG);
  private _userService = inject(UserService);
  private _storeService = inject(StoreService);

  searchUsers(query: string) {
    if (this.config.searchMode === 'possibleParticipant' || this.config.searchMode === 'possibleActionItemAssignee') {
      const orgId = this.config.organizationId ?? (this._storeService.currentPssr()?.OrganizationID || 0);
      return this._userService.searchParticipants(query, orgId);
    }

    if (this.config.searchMode === 'pssrMember') {
      return this._userService.autocompleteUsersByBU(this._storeService.currentBu()?.Id || 0, query);
    }

    return this._userService.searchUser(query);
  }
}
